const elements = document.querySelectorAll('.footer__heading--accordion');

const MobileAccordion = () => {

    Array.from(elements).forEach(element => {

        element.addEventListener('click' , () => {
            toggleAccordion(element);
        });

    });
}

function toggleAccordion(item) {

    item.classList.toggle('footer__heading--active');
    item.nextElementSibling.classList.toggle('footer__accordion--active');

}

export default MobileAccordion;